import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import localStore from '@service/local-store'

const useLocalState = <T>(
  key: string,
  defaultValue?: T
): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState<T>(defaultValue || localStore.get(key))

  useEffect(() => {
    localStore.set(key, state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return [state, setState]
}

export default useLocalState
